<ng-template #preHeader>
    CELEBRATE WITH
</ng-template>
<div class="auth-for-birthday-rewards__animation" directive-lottie="birthday-rewards"></div>
<shared-auth-header [preHeader]="preHeader" [description]="description">
    Birthday Rewards!
</shared-auth-header>
<ng-template #description>
    Add your birthday to your profile and we will send you a little something special on your birthday.
</ng-template>
<shared-form-for-birthday-rewards [modalId]="modalData?.id" [modal]="true"></shared-form-for-birthday-rewards>